import { useToast } from 'primevue';

export const useAlmost = () => {
  const toast = useToast();

  const showAlmost = (details?: string) => {
    toast.add({
      closable: true,
      life: 3_000,
      summary: 'Feature bientôt disponible',
      severity: 'info',
      ...(details && { detail: details }),
    });
  };
  return { showAlmost };
};
